/* eslint-disable no-unused-vars */
import { useRouter } from 'next/router';
import Link from 'next/link';
import cn from 'classnames';

import Button from 'react-scale/components/elements/button';
import { Fragment } from 'react';

const CTAS = ({ theme, ctas, themeColors, size, fullWidth = false }) => {
  const router = useRouter();

  return (
    <div
      className={cn(
        'flex flex-wrap sm:flex-nowrap w-full lg:justify-start',
        size === 'small' ? 'gap-4' : 'gap-6',
        fullWidth ? 'sm:w-full' : 'sm:w-auto'
      )}
    >
      {ctas.map((cta, i) => {
        let href;

        // All CTAs that redirects to the dashboard should pass all current props
        if (cta.href?.startsWith('https://dashboard.scale.com')) {
          const ctaHrefURL = new URL(cta.href);
          const currentURL = new URL(router.asPath, 'https://scale.com');

          const query = {};

          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of ctaHrefURL.searchParams) {
            query[key] = value;
          }
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of currentURL.searchParams) {
            query[key] = value;
          }

          href = {
            pathname: cta.href.split('?')[0],
            query
          };
        }

        return (
          <Button
            /* eslint-disable react/no-array-index-key */
            key={i}
            theme={theme}
            text={cta.text}
            type={cta.type}
            variant={cta.variant}
            size={cta.size || size}
            href={href ?? cta.href}
            borderColor={cta.borderColor}
            themeColors={themeColors}
            target={cta.target}
            fullWidth={fullWidth}
          />
        );
      })}
    </div>
  );
};

CTAS.defaultProps = {
  theme: 'dark',
  ctas: [
    {
      text: 'Get Started',
      href: '/rapid',
      type: 'primary',
      variant: 'default'
    },
    {
      text: 'Book a Demo',
      href: '/sales'
    }
  ]
};

export default CTAS;
